import React from "react";
import Button from "../form/Button";
import Modal from "../elements/Modal";

const PopUpModal = ({
  open = false,
  onClose = () => {},
  loading = false,
  customMessage,
  deleteButtonIcon,
  titleIcon,
  title,
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={() => onClose()}
      title={title}
      size="sm"
      modaltitleClasses={"!text-slate-200 text-[15px]"}
      headerClass={"!bg-black !rounded-t-lg !text-white"}
      childrenClasses={"!rounded-b-lg"}
      titleIcon={titleIcon}
    >
      <div className="text-center mb-3 text-slate-600 text-md">
        {customMessage ? (
          customMessage
        ) : (
          <></>
        )}
      </div>
     
    </Modal>
  );
};

export default PopUpModal;
